<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Świadczone usługi</div>

        <p>Lista usług udostępnianych przez Partnera</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs6 class="mt-3">Aktywne usługi</v-flex>

      <v-flex text-xs-right>
        <check-permission permissions="BENEFIT.ADD" entityType="partner" :entityId="partnerId">
          <v-btn large color="error" @click="showAddModal">DODAJ USŁUGĘ</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <v-layout row v-for="(item, index) in list" :key="index">
      <v-flex xs2>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on">
              <v-avatar class="secondary">
                <v-icon color="white">{{ item.displayType }}</v-icon>
              </v-avatar>
              {{ item.displayValue }}
            </v-chip>
          </template>
          <span>{{ benefitType(item.type) }}</span>
        </v-tooltip>
      </v-flex>

      <v-flex xs7>
        <h3>{{ item.name }}</h3>

        <p>
          <span v-if="item.place" class="mr-2">
            <v-icon small class="mr-1">mdi-bank</v-icon>

            <span>{{ item.place.name }}</span>
          </span>

          <span v-if="item.displayGroups" class="mr-2">
            <v-icon small class="mr-1">mdi-account-group</v-icon>

            <span>{{ item.displayGroups }}</span>
          </span>

          <span v-if="item.displayCategories" class="mr-2">
            <v-icon small class="mr-1">mdi-pound</v-icon>

            <span>{{ item.displayCategories }}</span>
          </span>

          <span v-if="item.start || item.end">
            <v-icon small class="mr-1">mdi-calendar</v-icon>

            <span v-if="item.start && item.end">Ważna od {{ item.start }} do {{ item.end }}</span>

            <span v-else-if="item.start">Ważna od {{ item.start }}</span>

            <span v-else-if="item.end">Ważna do {{ item.end }}</span>
          </span>
        </p>
      </v-flex>

      <v-flex xs3 class="text-xs-right">
        <check-permission permissions="BENEFIT.UPDATE" entityType="benefit" :entityId="item.id">
          <v-btn icon flat color="primary" @click="showEditModal(item.id)">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </check-permission>

        <check-permission permissions="BENEFIT.DELETE" entityType="benefit" :entityId="item.id">
          <v-btn icon flat color="error" @click="showDeleteDialog(item.id)">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <add :show="showModal" :id="idToEdit" @close="hideModal" @update="update" @save="add"></add>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy napewno chcesz usunąć usługę?"
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    ></material-dialog>
  </material-card>
</template>

<script>
import { mapState } from 'vuex';
import { BenefitType, benefitType, DisplayBenefitType, BenefitIconTypeTranslation } from '@witkac/kartamiejska-shared';

import Add from './modals/AddBenefit.modal';
import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Wyświetlanie usług Partnera
// @group Partners
export default {
  mixins: [
    modalMixin('partners/benefits', {
      getError: 'Wystąpił błąd podczas pobierania danych usługi.',
      added: 'Dodano usługę.',
      addError: 'Nie udało się dodać usługi.',
      updated: 'Zaktualizowano usługę.',
      updateError: 'Nie udało się zaktualizować usługi.'
    }),
    notificationsMixin
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    Add
  },
  data() {
    return {
      idToDelete: undefined
    };
  },
  methods: {
    // @vuese
    // Metoda dostosowuje usługę do prawidłowego wyświetlenia informacji
    // @arg `list` - tablica usług
    setDisplayData(list) {
      list.forEach(benefit => {
        benefit.displayType = BenefitIconTypeTranslation[BenefitType[benefit.type]];
        if (benefit.type === DisplayBenefitType.PERCENT_DISCOUNT) {
          benefit.displayValue = benefit.value + ' %';
        } else {
          benefit.displayValue = benefit.value;
        }
        if (benefit.groups) {
          benefit.displayGroups = benefit.groups.map(group => group.name).join(', ');
        }
        if (benefit.categories) {
          benefit.displayCategories = benefit.categories.map(category => category.name).join(', ');
        }
      });
    },
    // @vuese
    // Otwiera okienko z potwierdzeniem usunięcia
    // @arg `id` - identyfikator usługi
    showDeleteDialog(id) {
      this.idToDelete = id;
    },
    // @vuese
    // Ukrywa okienko z potwierdzeniem usunięcia
    hideDeleteDialog() {
      this.idToDelete = undefined;
    },
    // @vuese
    // Usuwa usługę
    // @arg `id` - identyfikator usługi
    remove(id) {
      this.$store
        .dispatch('partners/benefits/remove', id)
        .then(() => this.notifySuccess('Usunięto usługę.'))
        .catch(err => this.notifyError('Nie udało się usunąć usługi.'));
    },
    benefitType
  },
  watch: {
    list(array) {
      this.setDisplayData(array);
    }
  },
  beforeMount() {
    this.setDisplayData(this.list);
  },
  computed: {
    ...mapState({
      list: state => state.partners.benefits.list,
      partnerId: state => state.partners.id
    })
  }
};
</script>

<style>
table {
  width: 100%;
}
td {
  white-space: nowrap;
}
.mainText {
  width: 100%;
  padding-left: 0.5em;
}
</style>
